import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ItemLocationDetailFragment = { __typename?: 'ItemLocation', id: string, name: string, type?: string | null, disabled_at?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null };

export const ItemLocationDetailFragmentDoc = gql`
    fragment ItemLocationDetail on ItemLocation {
  id
  name
  type
  disabled_at
  event_account {
    id
    name
  }
  event {
    id
    name
  }
}
    `;